import Assistantlist from './components/Assistantlist/Assistantlist';
import AssistantsHeader from './components/Assistantsheader/Assistantsheader';

const AssistantsPage = () => {
  return (
    <div className="assistants-page">
      <AssistantsHeader />
      <Assistantlist />
    </div>
  );
};

export default AssistantsPage;
